var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"input",attrs:{"type":"number","inputmode":"numeric","hide-spin-buttons":""},on:{"keydown":_vm.onKeyDown,"keyup":function($event){return _vm.$emit('keyup', $event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }